import {Injectable} from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import {confirm} from 'devextreme/ui/dialog';
import {Observable} from 'rxjs';
import {DirtyComponent} from '../utils';
import {FusionAuthService} from "../services/fusion-auth";
import {LabSettings} from "../models/ocl";

@Injectable({providedIn: 'root'})
export class DirtyCheckGuard  {

  public canDeactivate(
    component: DirtyComponent,
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {



    return component.canDeactivate() ? confirm('There are unsaved changes. Do you want to continue and lose these changes?', 'Unsaved changes') : true;
  }
}
